/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateTemplate
 */
export interface CreateTemplate {
  /**
   *
   */
  name: string;
  /**
   *
   */
  simulation: string;
  /**
   *
   */
  includeEvents?: boolean;
  /**
   *
   */
  includeInitials?: boolean;
  /**
   *
   */
  includeSettings?: boolean;
}

/**
 * Check if a given object implements the CreateTemplate interface.
 */
export function instanceOfCreateTemplate(value: object): value is CreateTemplate {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("simulation" in value) || value["simulation"] === undefined) return false;
  return true;
}

export function CreateTemplateFromJSON(json: any): CreateTemplate {
  return CreateTemplateFromJSONTyped(json, false);
}

export function CreateTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateTemplate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    simulation: json["simulation"],
    includeEvents: json["include_events"] == null ? undefined : json["include_events"],
    includeInitials: json["include_initials"] == null ? undefined : json["include_initials"],
    includeSettings: json["include_settings"] == null ? undefined : json["include_settings"],
  };
}

export function CreateTemplateToJSON(json: any): CreateTemplate {
  return CreateTemplateToJSONTyped(json, false);
}

export function CreateTemplateToJSONTyped(
  value?: CreateTemplate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    simulation: value["simulation"],
    include_events: value["includeEvents"],
    include_initials: value["includeInitials"],
    include_settings: value["includeSettings"],
  };
}
